// Add your custom routes here
// @reference:  https://router.vuejs.org/ 
const customRoutes = [
    
    // example: 
    // {path: "/shop/:productId", component: PageShop, props: true}
];